import React from 'react';
import { LanguageSelect } from './language-select';
import { ShippingCountrySelect } from './shipping-country-select';

export const LocalizationMenu = ({ onBlur, showRegionSelection }) => (
    <div className="mt-3">
        {showRegionSelection && (
            <>
                <ShippingCountrySelect onShippingCountrySelected={onBlur} />
                <div className="border-bottom" />
            </>
        )}
        <>
            <LanguageSelect onLanguageSelected={onBlur} inProfileMenu={false} />
            <div className="border-bottom" />
        </>
    </div>
);
